import { PvSelect } from 'components/form/PvSelect';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { I18n, Translate } from 'react-redux-i18n';
import { Flex, Label } from 'rebass';
import { reduxForm } from 'redux-form';
import styled from 'styled-components';
import { space, width } from 'styled-system';
import { PvBox, PvButton, PvInput } from 'styles/CustomComponents';
import {
  examClassesToDropdown,
  lessonTypes,
  getLabel,
  shouldSelectExamClass,
} from "../../util/SearchUtil";

const PvSearchBtn = styled(PvButton)`
  ${space}
  ${width}
`;

const searchDisabled = (searchTerms) => {
  return !(!!searchTerms.examClass && !!searchTerms.lessonType && !!searchTerms.courseNumber && !!searchTerms.courseYear && !!searchTerms.courseUnit);
};

const STATUS_VALUES = [
  { label: I18n.t("search.include_active"), value: "INCLUDE_ACTIVE" },
  { label: I18n.t("search.include_dropped"), value: "INCLUDE_DROPPED" }
];

class LessonsReportSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      executeSearch: true
    };
    const {searchTerms, examClasses} = this.props;
    // Select exam class if there is only one
    if (shouldSelectExamClass(searchTerms, examClasses)) {
      this.validateAndUpdateSearchTerms({ examClass: examClasses[0] });
    }
    if (!!searchTerms && searchTerms.lessonType === "" ) {
      this.validateAndUpdateSearchTerms({ lessonType: "THEORY" });
    }
    if (!!searchTerms && searchTerms.applicantStatus === "" ) {
      this.validateAndUpdateSearchTerms({ applicantStatus: "INCLUDE_ACTIVE" });
    }
  }

  componentDidUpdate(prevProps) {
    // execute search automatically after first load
    if (this.state.executeSearch) {
      this.setState({ executeSearch: false });
      this.props.searchFn(this.props.searchTerms);
    }
  }
  
  validateAndUpdateSearchTerms(terms) {
    this.props.updateSearchTerms(terms);
  };

  render() {
    const {
      searchFn,
      searchTerms,
      examClasses,
      loading
    } = this.props;

    return (
      <PvBox my={3}>
        <form>
          <Flex flexWrap='wrap'>
            <PvBox mb={[0, 0, 3]} w={[1, 1, 1]}>
              <PvBox display='inline-block' px={2} pb={3} mb={3} w={[1 / 3, 1 / 3, 1 / 12]}>
                <Label mb={2}>
                  <Translate value='search.course_number' />
                </Label>
                <PvInput py={3}
                         name='courseNumber'
                         value={this.props.searchTerms.courseNumber}
                         disabled
                />
              </PvBox>
              <PvBox display='inline-block' px={2} pb={3} mb={3} w={[1 / 3, 1 / 3, 1 / 12]}>
                <Label mb={2}>
                  <Translate value='search.course_year' />
                </Label>
                <PvInput name='courseYear'
                         value={this.props.searchTerms.courseYear}
                         disabled
                />
              </PvBox>
              <PvBox display='inline-block' px={2} pb={3} mb={3} w={[1 / 3, 1 / 3, 2 / 12]}>
                <Label mb={2}>
                  <Translate value='search.course_unit' />
                </Label>
                <PvInput name='courseUnit'
                         value={this.props.searchTerms.courseUnit}
                         disabled
                />
              </PvBox>
              <PvBox display='inline-block' px={2} mb={3} w={[1 / 2, 1 / 2, 2 / 12]}>
                <Label mb={2}>
                  <Translate value='search.lesson_type' />
                </Label>
                <PvSelect
                  placeholder=''
                  name='lessonType'
                  options={lessonTypes()}
                  value={{
                    value: this.props.searchTerms.lessonType,
                    label: getLabel(this.props.searchTerms.lessonType, lessonTypes())
                  }}
                  onChange={(option) => this.validateAndUpdateSearchTerms({lessonType: option.value})}
                />
              </PvBox>
              <PvBox minWidth='8em' display='inline-block' px={2} pb={3} mb={3} w={[1 / 3, 1 / 3, 2 / 12]}>
                <Label mb={2}>
                  <Translate value='search.exam_class' />
                </Label>
                <PvSelect
                  placeholder=''
                  options={examClassesToDropdown(examClasses)}
                  value={{value: searchTerms.examClass, label: searchTerms.examClass}}
                  onChange={(option) => this.validateAndUpdateSearchTerms({examClass: option.value})}
                  isLoading={loading}
                />
              </PvBox>
              <PvBox display='inline-block' px={2} pb={3} mb={3} w={[1 / 3, 1 / 3, 2 / 12]}>
                <Label mb={2}>
                  <Translate value='search.applicant_status' />
                </Label>
                <PvSelect
                  placeholder=''
                  options={STATUS_VALUES}
                  value={{value: searchTerms.applicantStatus, label: getLabel(searchTerms.applicantStatus, STATUS_VALUES)}}
                  onChange={(option) => this.validateAndUpdateSearchTerms({applicantStatus: option.value})}
                  isLoading={loading}
                />
              </PvBox>
              <PvBox display='inline-block' px={2} pb={3} mb={3} w={[1 / 4, 2 / 8, 2/ 12]}>
                <PvSearchBtn px={3} width='100%'
                             disabled={searchDisabled(searchTerms)}
                             onClick={(e) => {
                               e.preventDefault();
                               searchFn(searchTerms);
                             }}>
                  <Translate value='action.search' />
                </PvSearchBtn>
              </PvBox>
            </PvBox>
          </Flex>
        </form>
      </PvBox>
    );
  }
}

LessonsReportSearch.propTypes = {
  lessons: PropTypes.array,
  route: PropTypes.object,
  loading: PropTypes.bool,
  searchFn: PropTypes.func,
  searchTerms: PropTypes.object,
  examClasses: PropTypes.array,
};

const mapStateToProps = (state) => {
  return {
    route: state.routing.location,
    lessons: state.general.lessons,
    loading: state.general.loading,
    examClasses: state.userState.courseData
      ? state.userState.courseData.examClasses
      : [],
  };
};

export default reduxForm({
  form: 'search'
})(connect(
  mapStateToProps
)(LessonsReportSearch));



// WEBPACK FOOTER //
// ./src/containers/search/LessonsReportSearch.jsx